module.exports = __webpack_public_path__ + "static/media/laptop.caf670aa.png";